import { render } from "./press.vue?vue&type=template&id=666e9101&scoped=true"
import script from "./press.vue?vue&type=script&lang=js"
export * from "./press.vue?vue&type=script&lang=js"

import "./press.vue?vue&type=style&index=0&id=666e9101&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666e9101"]])

export default __exports__